import styled from 'styled-components';
import { spacer12, Type } from '@spotify-internal/encore-web';

export const UserLinkTitle = styled(Type.span)`
  margin-left: ${spacer12};
`;
